import HeroSection from "./components/HeroSection";
import ValuesSection from "./components/ValuesSection";
import ServicesSection from "./components/ServicesSection";
import TeamSection from "./components/TeamSection";
import CompareSection from "./components/CompareSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "集團品牌介紹｜速築美宅家 Chronos Space",
  "description": "速築美宅家 Chronos Space 整合建築設計、預製工法、營造施工、室內裝修與軟裝美學，協助自地自建與危老重建業主完成高品質住宅。",
  "mainEntity": {
    "@type": "Organization",
    "name": "速築美宅家 Chronos Space",
    "alternateName": "Chronos Space",
    "url": siteUrl,
    "description": "自地自建與危老重建的整合顧問集團，以極速效率、淨零永續、舒適效能為品牌核心價值。",
    "foundingDate": "2020",
    "areaServed": ["台北", "新竹", "台中", "台南", "屏東"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "五大專業領域",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "建築設計" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "預製工法" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "營造施工" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "室內裝修" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "軟裝美學" } }
      ]
    }
  }
};

export default function About() {
  return (
    <main>
      <SEOMeta
        title="集團品牌介紹"
        description="速築美宅家 Chronos Space 整合建築設計、預製工法、營造施工、室內裝修與軟裝美學，協助自地自建與危老重建業主完成高品質住宅。"
        keywords="速築美宅家品牌,Chronos Space介紹,建築整合集團,自地自建顧問,危老重建整合"
        canonicalPath="/about"
        ogType="profile"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <ValuesSection />
      <ServicesSection />
      <TeamSection />
      <CompareSection />
      <FinalCtaSection />
    </main>
  );
}